<template>
	<div class="box">
		<div class="title">
			<div>
				<h2>{{ titleCn }}</h2>
				<h3>{{ titleEn }}</h3>
				<p v-html="text"></p>
			</div>
		</div>
		<div class="swiper_container">

			<swiper class="swiImgs reativeSwiper" :options="swiperOption" v-if="commodity.length != 0">
				<swiper-slide v-for="(item, index) in swiperList" data-index="index" :key="index" class="item_slide">
					<div class="item_box">
						<div class="companylogo">
							<img src="../../assets/img/logo.png" alt="">
						</div>
						<div class="item_list" @click="detail(eve)" v-for="(eve, indexs) in swiperList[index]"
							:key="indexs">
							<div class="imgbox">
								<div :style="'background-image: url('+eve.showpath+');'"></div>
							</div>
							<div class="txt">{{ eve.title }}</div>
						</div>
					</div>
				</swiper-slide>
				<div class="swiper-pagination" slot="pagination"></div>
			</swiper>
			<!-- <span class="swiText" v-if="commodity"
        >{{ imgIndex }}/{{ commodity.length }}</span
      > -->
		</div>
		<div class="down_box">
			<div class="down_info">
				<p>业务咨询电话</p>
				<el-table :data="tableData" border style="width: 100%" :header-cell-style="{
            background: '#3482E7',
            color: '#FFFFFF',
          }">
					<el-table-column prop="content" label="查询事项" width="400">
					</el-table-column>
					<el-table-column prop="link" label="联系方式"> </el-table-column>
				</el-table>
				<div style="background:#FFFFFF;margin-top:20px;margin-bottom:20px;padding:10px">
					<el-row>
						<el-col style="margin-top:20px" :span="12">TEX(电话)：{{arr.company_phone}}</el-col>
						<el-col style="margin-top:20px" :span="12">E-Mail(邮箱))：{{arr.email}}</el-col>
						<el-col :span="12" style="margin-top:20px">Fax(传真))：{{arr.fax}}</el-col>

						<el-col :span="12" style="margin-top:20px">Add(地址))：{{arr.address}}</el-col>
						<el-col :span="12" style="margin-top:20px">QQ(qq)：{{arr.qq}}</el-col>
					</el-row>
				</div>
				<!-- <img src="@/assets/del/phonePic.jpg" alt="" /> -->
			</div>
		</div>


		<el-dialog :visible.sync="dialogVisible" width="50%">
			<div>
				<div class="htmlbox" style="padding: 0 20px;" v-html="curScope.descp"></div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import "swiper/dist/css/swiper.css";
	export default {
		components: {
			swiper,
			swiperSlide,
		},
		data() {
			const that = this;
			return {
				arr: {
					address: "南京市中山东路300号长发中心2号楼7层e座",
					company_phone: "025-00000000",
					cox: "118.797593",
					coy: "32.04029",
					create_by: "1",
					create_time: "2020-12-25 16:01:46",
					delflag: "0",
					email: "xxxxxxxx",
					fax: "025-00000000",
					master_name: "中艺储运江苏有限公司",
					master_uuid: "0210f5ad12754562af223bf859838735",
					phone: "025-00000000",
					qq: "xxxxxxxxxx",
				},
				parallax: true,
				titleCn: "我们的服务",
				titleEn: "OUR SCOPE OF SERVICE",
				text: "中艺储运江苏有限责任公司服务覆盖全国各区域，其中尤以湖南、湖北、江西、安徽、江苏、上海及周边地区为主；主要从事长江中下游区域进出口货物的海、陆、空、拖车、仓储、DDU、DDP等国际货运代理业务。",
				// text: "中艺国际储运公司江苏公司主要从事江苏、上海及周边地区和长江中下游区域进出口货物的海、陆、空国际货运代理业务，包括：揽货、包装、存储、集装箱拆拼装箱服务、送货上门、短途运输服务、保险、报检、报关、订舱、转运、缮制各种单证；国际船舶代理，无船承运业务。",
				swiperOption: {
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
				},
				commodity: [],
				/* commodity: [{
						imgUrl: "scop1",
						name: "海运集装箱",
					},
					{
						imgUrl: "scop2",
						name: "铁路",
					},
					{
						imgUrl: "scop3",
						name: "海铁联运",
					},
					{
						imgUrl: "scop4",
						name: "拖车",
					},
					{
						imgUrl: "scop5",
						name: "仓储",
					},
					{
						imgUrl: "scop6",
						name: "物流",
					},
					{
						imgUrl: "scop7",
						name: "配送",
					},
					{
						imgUrl: "scop8",
						name: "DDP",
					},
					{
						imgUrl: "scop9",
						name: "DDU",
					},
				], //这里就使用假数据了， */
				imgIndex: 1,
				swiperOption: {
					// el: ".swiper-pagination",
					dynamicBullets: true,
					draggable: true,
					notNextTick: true, //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
					// loop: true, //循环
					initialSlide: 0, //设定初始化时slide的索引
					// autoplay: true, //自动播放
					speed: 800, //滑动速度
					direction: "horizontal", //滑动方向
					grabCursor: true, //小手掌抓取滑动
					on: {
						//滑动之后回调函数
						slideChangeTransitionStart: function() {
							that.imgIndex = this.realIndex +
								1; //获取轮播图片下标索引；这里有一个坑，之前网上找到的是用activeIndex，但后来网上说的是这个realIndex，原来activeIndex是swiper2.0的；而realIndex是swiper3.0的，（使用realIndex才实现了下标索引）
						},
					},
					observeParents: true, //修改swiper自己或子元素时，自动初始化swiper
					observer: true, //修改swiper的父元素时，自动初始化swiper
					pagination: {
						//分页器设置
						el: ".swiper-pagination",
						clickable: true,
						type: "bullets",
					},
				},
				tableData: [{
						seach: "项目合作及合同签订事项",
						phone: " 周云虎：025-8xxxxxxx  邮箱：vinson_zhou@js-chinaarts.com",
					},
					{
						seach: "海运市场业务及运价查询",
						phone: "吴玉峰：025-8xxxxxxx 邮箱：fred_wu@js-chinaarts.com",
					},
					{
						seach: "操作及客户服务",
						phone: "尤静：025-8xxxxxxx",
					},
					{
						seach: "空运业务及运价查询",
						phone: "联系电话：025-8xxxxxxx、8xxxxxxx",
					},
				],
				curScope: {},
				dialogVisible: false
			};
		},
		methods: {
			//获取业务范围列表
			getScopeData() {
				this.$axios({
						method: "get",
						url: "/webpc/yewufangwei/list"
					})
					.then((res) => {
						if (res.data.result == 200) {
							let scopes = res.data.detail;
							this.commodity = scopes.filter(item => {
								return item.msgtype != '9'
							})

							let ourServe = scopes.filter(item => {
								return item.msgtype === '9'
							})
							console.log('ourServe', ourServe)
							if (ourServe.length > 0) {
								this.text = ourServe[0].descp
							}
						} else {
							this.$message.warning(res.data.description)
						}
					});
			},
			//获取业务详情
			detail(obj) {
				this.curScope = obj;
				this.dialogVisible = true;
			},
			list() {
				var that = this;
				that.$http
					.get(
						"webpc/pcbusinessinfo/list", {
							params: {
								page: 1,
								pagesize: 50000,
							},
						}, {
							emulateJSON: true,
						}
					)
					.then((res) => {
						// console.log(result.data);
						// this.list = result.body.rows
						if (res.data.result == 200) {
							that.tableData = res.data.detail.list;
							// console.log(this.jianjie);
						}
					});
				that
					.$axios({
						method: "get",
						url: "webpc/pcmastercompany/list",
						// data: this.$qs.stringify(data)
						params: {
							// location:0
						},
					})
					.then((res) => {
						that.arr = res.data.detail;
					});
			},
			handelToscopeDetail(item, index) {
				let obj = JSON.stringify(item);
				this.$router.push({
					path: `/scopeDetail?showData=${obj}`,
				});
			},
			getImgUrl(icon) {
				//展示图片
				return require(`@/assets/del/${icon}.jpg`);
			},
		},
		computed: {
			swiperList() {
				if (
					this.commodity &&
					Array.isArray(this.commodity) &&
					this.commodity.length > 0
				) {
					if (this.commodity.length <= 9) {
						return [
							[...this.commodity]
						];
					} else {
						let arrLength = this.commodity.length;
						let newLength = parseInt(arrLength / 9) + 1;
						let returnArr = [];
						for (var i = 0; i < newLength; i++) {
							returnArr[i] = [];
							returnArr[i] = [...this.commodity.slice(i * 9, (i + 1) * 9)];
						}
						return returnArr;
					}
				}
			},
		},
		mounted() {
			this.list();
			this.getScopeData();
		},
	};
</script>

<style lang="scss" scoped>
	::v-deep.swiper-pagination {
		bottom: 50px;

		.swiper-pagination-bullet {
			width: 9px;
			height: 9px;
			background-color: #a39bb1;
			opacity: 1;
		}

		.swiper-pagination-bullet-active {
			width: 62px;
			height: 9px;
			background-color: #d5d4df;
			border-top-left-radius: 6px;
			border-top-right-radius: 6px;
			border-bottom-left-radius: 6px;
			border-bottom-right-radius: 6px;
		}
	}

	.commodity {
		background: #f5f5f5;

		.container {
			position: relative;

			.swiText {
				position: absolute;
				height: 0.5rem;
				width: 0.5rem;
				bottom: 0.2rem;
				right: 0.3rem;
				font-size: 0.33rem;
				color: #fff;
				z-index: 10;
			}

			.swiImgs {
				width: 100%;

				.item {
					height: 7.5rem;

					.swiImg {
						width: 100%;
					}
				}
			}
		}
	}

	.box {
		width: 100%;
		height: 100%;
		overflow: hidden;

		.title {
			width: 100%;
			background-color: #efefef;
			padding-top: 20px;

			div {
				margin: 0 auto;
				width: 1200px;
				height: 200px;
				background-color: #0070af;
				color: #ffffff;
				display: flex;
				flex-direction: column;
				justify-content: center;
				padding: 0 30px 0 20px;
				font-size: 18px;
				box-sizing: border-box;

				h2 {
					font-weight: 400;
					font-size: 24px;
				}

				h3 {
					font-size: 22px;
					margin-bottom: 14px;
					padding-bottom: 10px;
					border-bottom: 2px solid #ffffff;
					width: 300px;
					margin-top: 6px;
					font-weight: 200;
				}

				p {
					font-size: 15px;
				}
			}
		}

		.swiper_container {
			width: 100%;

			.companylogo {
				position: absolute;
				left: 402px;
				top: 286px;
				z-index: 100;
				width: 384px;
				height: 256px;
				background-color: rgba(255, 255, 255, 0.9);
				// display: flex;
				display: none;
				justify-content: center;
				align-items: center;

				img {
					width: 40%;
					height: auto;
				}
			}

			// height: 780px;

			.reativeSwiper {
				width: 100%;
				height: 100%;
				background-image: url("../../assets/del/scopeBG.jpg");
				background-repeat: no-repeat;
				background-size: 100% 100%;

				.item_slide {
					.item_box {
						width: 1230px;
						transform: translate(20px);
						height: auto;
						overflow: hidden;
						margin: 64px auto;
						display: flex;
						flex-wrap: wrap;
						position: relative;
						// justify-content: space-between;

						.item_list {
							width: 384px;
							margin-right: 18px;
							margin-bottom: 30px;
							float: left;
							display: flex;
							flex-direction: column;
							cursor: pointer;

							.imgbox {
								width: 100%;
								height: 220px;
								overflow: hidden;

								>div {
									height: 100%;
									background-repeat: no-repeat;
									background-size: cover;
									background-position: center;

									&:hover {
										transform: scale(1.1);
										transition: 0.3s all;
									}
								}

							}

							.txt {
								width: 100%;
								height: 36px;
								line-height: 36px;
								background-color: #2f3a4f;
								color: #ffffff;
								font-size: 16px;
								text-align: center;
							}
						}


					}
				}
			}
		}

		.down_box {
			width: 100%;
			background-color: #efefef;
			display: flex;
			justify-content: center;

			.down_info {
				width: 1200px;
				overflow: hidden;
				display: flex;
				flex-direction: column;
				padding: 10px;

				p {
					margin: 8px 0;
					font-size: 16px;
					color: #2d92cb;
					font-weight: 400;
				}

				img {
					margin-top: 20px;
					margin-bottom: 40px;
				}
			}
		}
	}

	.htmlbox {
		::v-deep img {
			max-width: 100%;

		}
	}
</style>